import React, { useMemo } from 'react';
import useOperatorsLoader from '@/widget/ui/hooks/useOperatorsLoader';
import { Operator } from '@/widget/domain/operator';
import { sampleSize } from 'lodash';
import styles from './OperatorsList.module.scss';

interface Props {
  operatorsList?: Operator[]
}

function OperatorsList({ operatorsList }: Props) {
  const { operators } = useOperatorsLoader();
  const actualOperators = useMemo(() => operatorsList || operators, [operatorsList, operators]);

  return (
    <div className={styles.container}>
      {sampleSize(actualOperators, 3).map((operator) => (
        <div key={operator.id} className={styles.operator}>
          <div
            className={styles.operatorAvatar}
          >
            <img src={operator.avatarUrl} alt="" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default OperatorsList;
